import { AxiosHeaders, AxiosRequestConfig } from "axios";

export const apiConfig: AxiosRequestConfig = {
  timeout: Math.round(2 * 60 * 1000),
  baseURL: import.meta.env.VITE_APP_API_URL,
  headers: new AxiosHeaders()
    .setContentType('application/json')
    .setAccept('application/json')
};
